import useVadWrapper from "./VadWrapper";
import useSttWrapper from "./SttWrapper";

export default function useSpeechWrapper({ mode = "vad", target = 35 } = {}) {
    if (mode === "stt") {
        const stt = useSttWrapper(target);
        return stt;
    }

    const vad = useVadWrapper(target, { startOnLoad: false });
    return vad;
}
